import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngxs/store';
import {hasPermisionEdit} from '@shared/utils';
import {Permiso} from "@shared/enums/permisos.enum";
import {MainState} from "@store/main.store";
import {RolAplicacion} from "@shared/enums/rol-aplicacion.enum";
@Component({
  selector: 'app-data-import-export',
  template: `
    <div class="inline-flex space-x-2 items-center {{styleClass}}">
      <ng-container *ngIf="showImport">
        <ng-container>
          <button
            id="data-export.import"
            [disabled]="!(isAdmin || (hasPermisionEdit && !isAdmin)) || disabled"
            azButton
            (click)="this.import.emit()"
            [azTooltip]="(tooltip ? tooltip : (importButtonName ? importButtonName : 'misc.importar')) | transloco"
            tooltipPosition="bottom"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M9.83 8H11v6h2V8h1.17L12 5.83z" opacity=".3"/><path fill="currentColor" d="M5 18h14v2H5zm0-8h4v6h6v-6h4l-7-7zm8-2v6h-2V8H9.83L12 5.83L14.17 8z"/></svg>
            <span *ngIf="importButtonName">{{ importButtonName | transloco }}</span>
            <span class="ellipsis"></span>
          </button>
        </ng-container>
      </ng-container>
      <az-overlay [template]="menuColumns" position="BOTTOM_RIGHT" [disabled]="disabled">
        <button id="data-export.export" azButton [azTooltip]="(tooltip ? tooltip : exportButtonName) | transloco" tooltipPosition="bottom" [disabled]="disabled">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M13 9V5h-2v6H9.83L12 13.17L14.17 11H13z" opacity=".3"/><path fill="currentColor" d="M15 9V3H9v6H5l7 7l7-7zm-3 4.17L9.83 11H11V5h2v6h1.17zM5 18h14v2H5z"/></svg>
          <span>{{ exportButtonName | transloco }}</span>
          <span class="dropdown-caret"></span>
        </button>
        <ng-template let-toppy #menuColumns>
          <div class="popover-dialog-list">
            <button (click)="this.export.emit('XLSX'); toppy.close()">
              <span>{{ 'misc.xlsx' | transloco }}</span>
              <span *ngIf="secondAction" class="ellipsis"></span>
            </button>
            <button (click)="this.export.emit('CSV'); toppy.close()">
              <span>{{ 'misc.csv' | transloco }}</span>
              <span *ngIf="secondAction" class="ellipsis"></span>
            </button>
          </div>
        </ng-template>
      </az-overlay>
    </div>
  `,
  styles: []
})
export class DataImportExportComponent implements OnInit {

  @Output() export = new EventEmitter<'XLSX' | 'CSV'>();
  @Output() import = new EventEmitter();
  @Input() permisoModificar: Permiso;
  @Input() showImport = true;
  @Input() small = false;
  @Input() exportButtonName = 'misc.exportar';
  @Input('styleClass') styleClass = "mx-2";
  @Input() importButtonName = 'misc.importar';
  @Input() disabled = false;
  @Input() tooltip;
  @Input() secondAction = false;
  isAdmin = false;
  hasPermisionEdit = false;

  constructor(private store: Store) {
    const miembro = this.store.selectSnapshot(MainState.miembro);

    if (miembro && (miembro.usuario.rolAplicacion === RolAplicacion.ADMIN.codigo || miembro.rol.id === RolAplicacion.ADMIN.id)) {
      this.isAdmin = true;
    }
  }

  ngOnInit(): void {
    if (this.permisoModificar) {
      this.hasPermisionEdit = hasPermisionEdit(this.store, this.permisoModificar);
    }
  }

}
